// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e8a5f2a7","977":"5c4f4419"}[chunkId] + ".chunk.js";
};